<template>
  <v-container class="limited">
    <beneficiary-data></beneficiary-data>
    <v-tabs v-model="active" color="transparent" slider-color="primary">
      <v-tab :key="1" ripple class="color-tab">Consulta</v-tab>
      <v-tab :key="2" ripple class="color-tab">Exame / Terapia</v-tab>
      <v-tab :key="3" ripple class="color-tab">Internação</v-tab>
      <v-tab :key="4" ripple class="color-tab">Outros</v-tab>
      <v-tab-item v-for="i in 4" :key="i" class="pt-2">
        <aba-item :tipo="i"></aba-item>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import BeneficiaryData from "@/components/BeneficiaryData";
import AbaItem from "./aba-item";

export default {
  name: "Expense",
  components: {
    BeneficiaryData,
    AbaItem
  },
  data() {
    return {
      active: null
    };
  }
};
</script>
<style>
.color-tab {
  color: #424242 !important;
}
</style>
